// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__vDBPO","logoIcon":"Logo_logoIcon__AFIxU","logoText":"Logo_logoText__retJ4"};